export default __webpack_public_path__ + "static/media/Programming Language Pragmatics.802949a0.pdf";